<template>
  <div class="opener pb-10">
    <v-container class="pa-0">
      <v-row>
        <v-col cols="12" md="7" :class="{ 'pb-0': $vuetify.breakpoint.xs, 'pt-8': $vuetify.breakpoint.xs }">
          <!-- Headline -->
          <p :style="{ 'font-size': $vuetify.breakpoint.xs ? '16px' : $vuetify.breakpoint.md ? '22px' : '30px' }" class="white--text" style="text-shadow: 1px 1px 10px rgba(63, 63, 63, 0.3)">
            Jetzt <span class="font-weight-medium" :style="{ 'font-size': $vuetify.breakpoint.xs ? '20px' : $vuetify.breakpoint.md ? '30px' : '36px' }">Traueranzeigen online gestalten</span><br>
            und sofort <span class="font-weight-medium" :style="{ 'font-size': $vuetify.breakpoint.xs ? '20px' : $vuetify.breakpoint.md ? '30px' : '36px' }">per Klick beauftragen</span>
          </p>

          <!-- Text -->
          <p :style="{ 'font-size': $vuetify.breakpoint.xs ? '14px' : $vuetify.breakpoint.md ? '20px' : '24px', 'margin-bottom': $vuetify.breakpoint.xs ? '' : '' }" class="white--text" style="text-shadow: 1px 1px 10px rgba(63, 63, 63, 0.3);">
            Mit der ersten Bestatter-Lösung zur vollständigen Automatisierung des Traueranzeigen-Prozesses.
          </p>

          <!-- Bullet Points -->
          <p :style="{ 'font-size': $vuetify.breakpoint.xs ? '11px' : $vuetify.breakpoint.md ? '18px' : '20px', 'margin-bottom': $vuetify.breakpoint.xs ? '20px' : '40px' }" class="white--text" style="text-shadow: 1px 1px 10px rgba(63, 63, 63, 0.3);">
            ✓  <span class="font-weight-medium">Anzeigen-Entwurf</span> an Angehörige sendbar<br>
            ✓  <span class="font-weight-medium">Verlagsübergreifend</span> buchen & abrechnen<br>
            ✓  <span class="font-weight-medium">Mehr Kunden</span> online gewinnen
          </p>

          <tradana-mail-entry :light="true" position="0"></tradana-mail-entry>
        </v-col>

        <!-- Image -->
        <v-col cols="12" md="5" :class="{ 'py-0': $vuetify.breakpoint.xs, 'pt-10': $vuetify.breakpoint.mdAndUp }">
          <img src="../../assets/home/Loesung_fuer_Bestattungsinstitute.png" alt="" class="vertical-align" style="width: 100%">
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MailEntry from '@/components/global/MailEntry.vue'
export default {
  components: {
    TradanaMailEntry: MailEntry
  }
}
</script>

<style scoped>
.opener {
  width: 100%;
  color: white;
  padding: 3%;
  background-image: linear-gradient(rgb(149, 180, 166), rgb(172, 206, 190))
}
</style>
